export default __webpack_public_path__ + "static/media/fire-hazard.eb294302.png";